export default "__VITE_ASSET__CfiOAdfs__"